import { render } from "./ManageMgmt.vue?vue&type=template&id=72a2416d"
import script from "./ManageMgmt.vue?vue&type=script&lang=js"
export * from "./ManageMgmt.vue?vue&type=script&lang=js"

import "./ManageMgmt.vue?vue&type=style&index=0&id=72a2416d&lang=css"

import exportComponent from "/var/www/html/youthmanna/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__